// extracted by mini-css-extract-plugin
module.exports = {"navigation":"block-navigation_navigation_2KipE"};